var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sm:tw-mx-0 tw-bg-white sm:tw-rounded-lg', _vm.shadowClass, { 'tw--mx-4 tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6': !_vm.noPadding }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }